import "../i18n";
import {useTranslation} from "react-i18next";


export default function TextInput({placeholder, name, onChange = null, error}) {
    const t = useTranslation()[0];
    return (
        <div className="mb-3">
            <label className="form-label">{t(name)}</label>
            <input placeholder={placeholder} type="text" name={name} className="form-control" onChange={onChange}/>
            {error && <p className="text-danger">{error}</p>}
        </div>
    );
}
